export interface ThemeColor {
    themeName: string;
    themeColor: string;
    themeMode: 'light' | 'dark' | 'system' | string;
    themeColorName: string;
  }
  
  export interface ThemeOption {
    name: string;
    icon: string;
    class: string;
    colors: ThemeColor[];
  }
  
  export const ThemeMode = {
    LIGHT: 'light',
    DARK: 'dark',
    SYSTEM: 'system'
  } as const;
  
  export const THEME_CONFIG: ThemeOption[] = [
    {
      name: 'Day Theme (Default)',
      icon: 'fa fa-sun',
      class: 'light',
      colors: [
        { themeName: 'bootstrap4-light-blue', themeColorName: 'blue', themeColor: 'bg-blue-500', themeMode: 'light' },
        { themeName: 'bootstrap4-light-purple', themeColorName: 'purple', themeColor: 'bg-purple-500', themeMode: 'light' },
        { themeName: 'saga-green', themeColorName: 'green', themeColor: 'bg-green-500', themeMode: 'light' },
        { themeName: 'md-light-indigo', themeColorName: 'indigo', themeColor: 'bg-indigo-500', themeMode: 'light' },
        { themeName: 'lara-light-teal', themeColorName: 'teal', themeColor: 'bg-teal-500', themeMode: 'light' },
        // { themeName: 'saga-blue', themeColorName: 'blue', themeColor: 'bg-blue-500', themeMode: 'light' },
        // { themeName: 'saga-purple', themeColorName: 'purple', themeColor: 'bg-purple-500', themeMode: 'light' },
        // { themeName: 'saga-orange', themeColorName: 'orange', themeColor: 'bg-orange-500', themeMode: 'light' },
        // { themeName: 'md-light-deeppurple', themeColorName: 'deeppurple', themeColor: 'bg-purple-500', themeMode: 'light' },
        // { themeName: 'mdc-light-indigo', themeColorName: 'indigo', themeColor: 'bg-indigo-500', themeMode: 'light' },
        // { themeName: 'mdc-light-deeppurple', themeColorName: 'deeppurple', themeColor: 'bg-purple-500', themeMode: 'light' },
        // { themeName: 'lara-light-blue', themeColorName: 'blue', themeColor: 'bg-blue-500', themeMode: 'light' },
        // { themeName: 'lara-light-indigo', themeColorName: 'indigo', themeColor: 'bg-indigo-500', themeMode: 'light' },
        // { themeName: 'lara-light-purple', themeColorName: 'purple', themeColor: 'bg-purple-500', themeMode: 'light' },
        // { themeName: 'soho-light', themeColorName: 'soho', themeColor: 'bg-dark-500', themeMode: 'light' },
        // { themeName: 'viva-light', themeColorName: 'viva', themeColor: 'bg-viva-500', themeMode: 'light' }
      ]
    },
    {
      name: 'Dark',
      icon: 'fa fa-moon',
      class: 'dark',
      colors: [
        { themeName: 'bootstrap4-dark-blue', themeColorName: 'blue', themeColor: 'bg-blue-900', themeMode: 'dark' },
        { themeName: 'bootstrap4-dark-purple', themeColorName: 'purple', themeColor: 'bg-purple-900', themeMode: 'dark' },
        { themeName: 'vela-green', themeColorName: 'green', themeColor: 'bg-green-900', themeMode: 'dark' },
        { themeName: 'md-dark-indigo', themeColorName: 'indigo', themeColor: 'bg-indigo-900', themeMode: 'dark' },
        { themeName: 'lara-dark-teal', themeColorName: 'teal', themeColor: 'bg-teal-900', themeMode: 'dark' }
        //{ themeName: 'vela-blue', themeColorName: 'blue', themeColor: 'bg-blue-500', themeMode: 'dark' },
        
        //{ themeName: 'vela-purple', themeColorName: 'purple', themeColor: 'bg-purple-500', themeMode: 'dark' },
        //{ themeName: 'vela-orange', themeColorName: 'orange', themeColor: 'bg-orange-500', themeMode: 'dark' },
        //{ themeName: 'md-dark-deeppurple', themeColorName: 'deeppurple', themeColor: 'bg-purple-500', themeMode: 'dark' },
        //{ themeName: 'mdc-dark-indigo', themeColorName: 'indigo', themeColor: 'bg-indigo-500', themeMode: 'dark' },
        //{ themeName: 'mdc-dark-deeppurple', themeColorName: 'deeppurple', themeColor: 'bg-purple-500', themeMode: 'dark' },
        //{ themeName: 'lara-dark-blue', themeColorName: 'blue', themeColor: 'bg-blue-500', themeMode: 'dark' },
        //{ themeName: 'lara-dark-indigo', themeColorName: 'indigo', themeColor: 'bg-indigo-500', themeMode: 'dark' },
        //{ themeName: 'lara-dark-purple', themeColorName: 'purple', themeColor: 'bg-purple-500', themeMode: 'dark' },
        //{ themeName: 'soho-dark', themeColorName: 'soho', themeColor: 'bg-dark-500', themeMode: 'dark' },
        //{ themeName: 'viva-dark', themeColorName: 'viva', themeColor: 'bg-viva-500', themeMode: 'dark' }
      ]
    },
    {
      name: 'System',
      icon: 'fa fa-desktop',
      class: 'system',
      colors: [
        { themeName: 'bootstrap4-light-blue', themeColorName: 'blue', themeColor: 'bg-blue-500', themeMode: 'system' },
        { themeName: 'bootstrap4-light-purple', themeColorName: 'purple', themeColor: 'bg-purple-500', themeMode: 'system' },
        { themeName: 'saga-green', themeColorName: 'green', themeColor: 'bg-green-500', themeMode: 'system' },
        { themeName: 'md-light-indigo', themeColorName: 'indigo', themeColor: 'bg-indigo-500', themeMode: 'system' },
        { themeName: 'lara-light-teal', themeColorName: 'teal', themeColor: 'bg-teal-500', themeMode: 'system' },
        // { themeName: 'bootstrap4', themeColorName: 'blue', themeColor: 'bg-blue-900', themeMode: 'system' },
        // { themeName: 'bootstrap4', themeColorName: 'purple', themeColor: 'bg-purple-900', themeMode: 'system' },
        // { themeName: 'saga', themeColorName: 'blue', themeColor: 'bg-blue-500', themeMode: 'system' },
        // { themeName: 'vela', themeColorName: 'blue', themeColor: 'bg-blue-500', themeMode: 'system' },
        // { themeName: 'saga', themeColorName: 'green', themeColor: 'bg-green-500', themeMode: 'system' },
        // { themeName: 'vela', themeColorName: 'green', themeColor: 'bg-green-500', themeMode: 'system' },
        // { themeName: 'saga', themeColorName: 'purple', themeColor: 'bg-purple-500', themeMode: 'system' },
        // { themeName: 'vela', themeColorName: 'purple', themeColor: 'bg-purple-500', themeMode: 'system' },
        // { themeName: 'saga', themeColorName: 'orange', themeColor: 'bg-orange-500', themeMode: 'system' },
        // { themeName: 'vela', themeColorName: 'orange', themeColor: 'bg-orange-500', themeMode: 'system' },
        // { themeName: 'md', themeColorName: 'indigo', themeColor: 'bg-indigo-500', themeMode: 'system' },
        // { themeName: 'md', themeColorName: 'deeppurple', themeColor: 'bg-purple-500', themeMode: 'system' },
        // { themeName: 'mdc', themeColorName: 'indigo', themeColor: 'bg-indigo-500', themeMode: 'system' },
        // { themeName: 'mdc', themeColorName: 'deeppurple', themeColor: 'bg-purple-500', themeMode: 'system' },
        // { themeName: 'lara', themeColorName: 'blue', themeColor: 'bg-blue-500', themeMode: 'system' },
        // { themeName: 'lara', themeColorName: 'indigo', themeColor: 'bg-indigo-500', themeMode: 'system' },
        // { themeName: 'lara', themeColorName: 'purple', themeColor: 'bg-purple-500', themeMode: 'system' },
        // { themeName: 'lara', themeColorName: 'teal', themeColor: 'bg-teal-500', themeMode: 'system' },
        // { themeName: 'soho', themeColorName: 'soho', themeColor: 'bg-dark-500', themeMode: 'system' },
        // { themeName: 'viva', themeColorName: 'viva', themeColor: 'bg-viva-500', themeMode: 'system' }
      ]
    }
  ] as const;

  export const THEME_CONFIG_NEW: any[] = [
    {
      name: 'Light Mode',
      icon: 'fa fa-sun',
      themeMode: 'light',
      selectedTheme: 'Aura',
      selectedColor: 'indigo',
      themes: [
        { themeName: 'Aura', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Lara', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Material', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Nora', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
      ],
    },
    {
      name: 'Dark Mode',
      icon: 'fa fa-moon',
      themeMode: 'dark',
      selectedTheme: 'Lara',
      selectedColor: 'indigo',
      themes: [
        // Lara Theme - Dark
        { themeName: 'Lara', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Aura', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Material', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Nora', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
      ],
    },
    {
      name: 'System',
      icon: 'fa fa-desktop',
      themeMode: 'system',
      selectedTheme: 'Lara',
      selectedColor: 'indigo',
      themes: [
        // Lara Theme - System
        { themeName: 'Lara', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Aura', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Material', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
        { themeName: 'Nora', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
      ],
    },
  ];


  export const ColorPreset = [
    {
      colorName: 'indigo',
      primary: {
        50: '{indigo.50}',
        100: '{indigo.100}',
        200: '{indigo.200}',
        300: '{indigo.300}',
        400: '{indigo.400}',
        500: '{indigo.500}',
        600: '{indigo.600}',
        700: '{indigo.700}',
        800: '{indigo.800}',
        900: '{indigo.900}',
        950: '{indigo.950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'emerald',
      primary: {
        50: '{emerald-50}',
        100: '{emerald-100}',
        200: '{emerald-200}',
        300: '{emerald-300}',
        400: '{emerald-400}',
        500: '{emerald-500}',
        600: '{emerald-600}',
        700: '{emerald-700}',
        800: '{emerald-800}',
        900: '{emerald-900}',
        950: '{emerald-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'green',
      primary: {
        50: '{green-50}',
        100: '{green-100}',
        200: '{green-200}',
        300: '{green-300}',
        400: '{green-400}',
        500: '{green-500}',
        600: '{green-600}',
        700: '{green-700}',
        800: '{green-800}',
        900: '{green-900}',
        950: '{green-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'lime',
      primary: {
        50: '{lime-50}',
        100: '{lime-100}',
        200: '{lime-200}',
        300: '{lime-300}',
        400: '{lime-400}',
        500: '{lime-500}',
        600: '{lime-600}',
        700: '{lime-700}',
        800: '{lime-800}',
        900: '{lime-900}',
        950: '{lime-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'red',
      primary: {
        50: '{red-50}',
        100: '{red-100}',
        200: '{red-200}',
        300: '{red-300}',
        400: '{red-400}',
        500: '{red-500}',
        600: '{red-600}',
        700: '{red-700}',
        800: '{red-800}',
        900: '{red-900}',
        950: '{red-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'orange',
      primary: {
        50: '{orange-50}',
        100: '{orange-100}',
        200: '{orange-200}',
        300: '{orange-300}',
        400: '{orange-400}',
        500: '{orange-500}',
        600: '{orange-600}',
        700: '{orange-700}',
        800: '{orange-800}',
        900: '{orange-900}',
        950: '{orange-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'amber',
      primary: {
        50: '{amber-50}',
        100: '{amber-100}',
        200: '{amber-200}',
        300: '{amber-300}',
        400: '{amber-400}',
        500: '{amber-500}',
        600: '{amber-600}',
        700: '{amber-700}',
        800: '{amber-800}',
        900: '{amber-900}',
        950: '{amber-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'yellow',
      primary: {
        50: '{yellow-50}',
        100: '{yellow-100}',
        200: '{yellow-200}',
        300: '{yellow-300}',
        400: '{yellow-400}',
        500: '{yellow-500}',
        600: '{yellow-600}',
        700: '{yellow-700}',
        800: '{yellow-800}',
        900: '{yellow-900}',
        950: '{yellow-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'teal',
      primary: {
        50: '{teal-50}',
        100: '{teal-100}',
        200: '{teal-200}',
        300: '{teal-300}',
        400: '{teal-400}',
        500: '{teal-500}',
        600: '{teal-600}',
        700: '{teal-700}',
        800: '{teal-800}',
        900: '{teal-900}',
        950: '{teal-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'sky',
      primary: {
        50: '{sky-50}',
        100: '{sky-100}',
        200: '{sky-200}',
        300: '{sky-300}',
        400: '{sky-400}',
        500: '{sky-500}',
        600: '{sky-600}',
        700: '{sky-700}',
        800: '{sky-800}',
        900: '{sky-900}',
        950: '{sky-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'blue',
      primary: {
        50: '{blue-50}',
        100: '{blue-100}',
        200: '{blue-200}',
        300: '{blue-300}',
        400: '{blue-400}',
        500: '{blue-500}',
        600: '{blue-600}',
        700: '{blue-700}',
        800: '{blue-800}',
        900: '{blue-900}',
        950: '{blue-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'violet',
      primary: {
        50: '{violet-50}',
        100: '{violet-100}',
        200: '{violet-200}',
        300: '{violet-300}',
        400: '{violet-400}',
        500: '{violet-500}',
        600: '{violet-600}',
        700: '{violet-700}',
        800: '{violet-800}',
        900: '{violet-900}',
        950: '{violet-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                   
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                   
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'indigo',
      primary: {
        50: '{indigo-50}',
        100: '{indigo-100}',
        200: '{indigo-200}',
        300: '{indigo-300}',
        400: '{indigo-400}',
        500: '{indigo-500}',
        600: '{indigo-600}',
        700: '{indigo-700}',
        800: '{indigo-800}',
        900: '{indigo-900}',
        950: '{indigo-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                   
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                   
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'purple',
      primary: {
        50: '{purple-50}',
        100: '{purple-100}',
        200: '{purple-200}',
        300: '{purple-300}',
        400: '{purple-400}',
        500: '{purple-500}',
        600: '{purple-600}',
        700: '{purple-700}',
        800: '{purple-800}',
        900: '{purple-900}',
        950: '{purple-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                   
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                   
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'fuchsia',
      primary: {
        50: '{fuchsia-50}',
        100: '{fuchsia-100}',
        200: '{fuchsia-200}',
        300: '{fuchsia-300}',
        400: '{fuchsia-400}',
        500: '{fuchsia-500}',
        600: '{fuchsia-600}',
        700: '{fuchsia-700}',
        800: '{fuchsia-800}',
        900: '{fuchsia-900}',
        950: '{fuchsia-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                   
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                   
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'pink',
      primary: {
        50: '{pink-50}',
        100: '{pink-100}',
        200: '{pink-200}',
        300: '{pink-300}',
        400: '{pink-400}',
        500: '{pink-500}',
        600: '{pink-600}',
        700: '{pink-700}',
        800: '{pink-800}',
        900: '{pink-900}',
        950: '{pink-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                   
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                   
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'rose',
      primary: {
        50: '{rose-50}',
        100: '{rose-100}',
        200: '{rose-200}',
        300: '{rose-300}',
        400: '{rose-400}',
        500: '{rose-500}',
        600: '{rose-600}',
        700: '{rose-700}',
        800: '{rose-800}',
        900: '{rose-900}',
        950: '{rose-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                   
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                   
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'slate',
      primary: {
        50: '{slate-50}',
        100: '{slate-100}',
        200: '{slate-200}',
        300: '{slate-300}',
        400: '{slate-400}',
        500: '{slate-500}',
        600: '{slate-600}',
        700: '{slate-700}',
        800: '{slate-800}',
        900: '{slate-900}',
        950: '{slate-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                   
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                   
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    },
    {
      colorName: 'gray',
      primary: {
        50: '{gray-50}',
        100: '{gray-100}',
        200: '{gray-200}',
        300: '{gray-300}',
        400: '{gray-400}',
        500: '{gray-500}',
        600: '{gray-600}',
        700: '{gray-700}',
        800: '{gray-800}',
        900: '{gray-900}',
        950: '{gray-950}',
      },
      semantic: {
        colorScheme: {
            light: {
                surface: {
                   
                    50: '{zinc.50}',
                    100: '{zinc.100}',
                    200: '{zinc.200}',
                    300: '{zinc.300}',
                    400: '{zinc.400}',
                    500: '{zinc.500}',
                    600: '{zinc.600}',
                    700: '{zinc.700}',
                    800: '{zinc.800}',
                    900: '{zinc.900}',
                    950: '{zinc.950}'
                }
            },
            dark: {
                surface: {
                   
                    50: '{slate.50}',
                    100: '{slate.100}',
                    200: '{slate.200}',
                    300: '{slate.300}',
                    400: '{slate.400}',
                    500: '{slate.500}',
                    600: '{slate.600}',
                    700: '{slate.700}',
                    800: '{slate.800}',
                    900: '{slate.900}',
                    950: '{slate.950}'
                }
            }
        }
    }
    }
  ] as const;

  export const DEFAULT_THEME: any = {
    name: 'Light Mode',
    icon: 'fa fa-sun',
    themeMode: 'light',
    selectedTheme: 'Lara',
    selectedColor: 'indigo',
    themes: [
      { themeName: 'Lara', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
      { themeName: 'Aura', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
      { themeName: 'Material', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
      { themeName: 'Nora', colors:['indigo', 'emerald', 'zinc', 'green', 'lime', 'red', 'orange', 'amber', 'yellow', 'teal', 'sky', 'blue', 'violet', 'purple', 'fuchsia', 'pink', 'rose', 'slate', 'gray'] },
    ],
  };

